export default __webpack_public_path__ + "media/vue/img/whence/guess-icon-40b4ddbf95cfa281d3620a0a0171e600.png";